import Body from 'commons/card/Body';
import { default as Card } from 'commons/card/CollapsableCard';
import Header from 'commons/card/Header';
import LoadingCard from 'commons/card/LoadingCard';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

export default function MediaCardTemplate(props) {
  const popsMemo = useMemo(() => props, [props]);

  return (
    popsMemo.isLoaded ? <Card
      expanded={popsMemo.data?.data?.length > 0 || props.exp === true}
      key={popsMemo.card.label + 'card'}>
      {!popsMemo.header && (<Header title={`${popsMemo.card.label}`}></Header>)}
      <Body>{popsMemo.children}</Body>
    </Card> : <LoadingCard title={`Chargement ${popsMemo.card.label}...`} />);
}

MediaCardTemplate.propTypes = {
  exp: PropTypes.bool
};